import React from 'react';
import { PillButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';
import './CancelWarningModal.css';

const CancelWarningModal = ({ show, onClose, onConfirm }) => {
  return (
    <Modal modernLayout isShowing={show} onClose={onClose} hideCloseButton>
      <div className="container">
        <img className="icon" alt="warning icon" width="36" height="36" src="/account/static/images/ic-warning.svg" />
        <b className="label">
          Canceling your plan will be effective immediately, and you will lose the remaining days in your free trial.
        </b>
        <div className="container buttonContainer">
          <PillButton modernLayout type="button" text="Keep Plan" onClick={onClose} />
          <PillButton
            modernLayout
            className="formSubmit hollow"
            type="button"
            text="Continue to Cancel"
            onClick={onConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CancelWarningModal;
